// Feedback destination for the source centric person page. It backs the banner feedback chip and is the
// fallback offered when the Usabilla survey cannot load (blocked scripts, tracking protection, outages).
export const SOURCE_CENTRIC_COMMUNITY_URL = 'https://community.familysearch.org/en/group/351-source-centric-person-page'
